export default __webpack_public_path__ + "static/media/icon-rouded.9e93e8fe.png";